/* eslint-disable @next/next/no-sync-scripts */
import React, { useState, useEffect, useRef } from 'react'
import { persistor, store } from '@/store/store'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import Layout from '@/components/Layout'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import '@/styles/globals.scss'
import { MsalProvider } from '@azure/msal-react'
import { msalInstance } from '@/utils/authConfig'
import { withLDProvider } from 'launchdarkly-react-client-sdk'
import { HubspotProvider } from 'next-hubspot'

export const ChatContext = React.createContext()

function MyApp({ Component, pageProps }) {
  const queryClient = new QueryClient()

  useEffect(() => {
    const handler = (event) => {
      if (event.key === 'logout-event' && event.newValue === 'started') {
        msalInstance.logoutRedirect({
          onRedirectNavigate: () => false,
        })
        window.location.reload()
      }
      if (event.key === 'login-event' && event.newValue === 'started') {
        msalInstance.loginRedirect({
          onRedirectNavigate: () => false,
        })
        window.location.reload()
      }
    }
    window.addEventListener('storage', handler)
    return () => {
      window.removeEventListener('storage', handler)
    }
  }, [])

  return (
    <>
      <Hydrated>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <QueryClientProvider client={queryClient}>
              <MsalProvider instance={msalInstance}>
                <HubspotProvider>
                <Layout>
                  <Component {...pageProps} />
                </Layout>
                </HubspotProvider>
              </MsalProvider>
            </QueryClientProvider>
          </PersistGate>
        </Provider>
      </Hydrated>
    </>
  )
}

const Hydrated = ({ children }) => {
  const [hydration, setHydration] = useState(false)

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setHydration(true)
    }
  }, [])
  return hydration ? children : null
}
export default withLDProvider({
  clientSideID: '65001457985fe9125d41b38e',
})(MyApp)